// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/player-stats-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamPlayerStatsGetBody,
  typeTeamPlayerStatsGetOutput200,
} from "../../sdk/team/postTeamPlayerStatsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamPlayerStatsGetQueryKey(
  payload: typeTeamPlayerStatsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return [
    "post:team:teamPlayerStatsGet",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamPlayerStatsGetOutput200,
    unknown,
    typeTeamPlayerStatsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamPlayerStatsGet(
  payload: typeTeamPlayerStatsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamPlayerStatsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamPlayerStatsGet(payload),
    ...resolvedOptions,
  });
}
